import React from 'react';
import { Route } from 'react-router-dom';

import EmployeesTab from './tabs/Employees/EmployeesTab';

import NavbarLocal from 'Components/Admin/NavbarLocal';

import { routes } from './routes/routes';
import { ADMIN_URL } from '../Admin/constants/constants';
import AppSwitch from 'Components/AppSwitch';

function Employees() {
  return (
    <div className="employees">
      <div className="employees__header">
        <NavbarLocal routes={routes} />
      </div>
      <div className="employees__main">
        <AppSwitch>
          <Route exact path={`/${ADMIN_URL}/employees/`} render={(routeProps) => <EmployeesTab {...routeProps} />} />
          <Route path={`/${ADMIN_URL}/employees/new-employee-form`} render={() => <div>Forma</div>} />
          <Route path={`/${ADMIN_URL}/employees/expenses/`} render={() => <div>22</div>} />
          <Route path={`/${ADMIN_URL}/employees/requests/`} render={() => <div>33</div>} />
          <Route path={`/${ADMIN_URL}/employees/payslips/`} render={() => <div>44</div>} />
          <Route path={`/${ADMIN_URL}/employees/assignments/`} render={() => <div>55</div>} />
          <Route path={`/${ADMIN_URL}/employees/allocations/`} render={() => <div>66</div>} />
        </AppSwitch>
      </div>
    </div>
  );
}

export default Employees;
